import { gql } from '@apollo/client'

import cardProfileProductFragment from './cardProfileProductFragment'

const inProfileCollectionsFragment = gql`
  fragment inProfileCollectionsFragment on PublicProfile {
    inProfileCollections {
      id
      slug
      publicCmsItem {
        id
        content
      }
      profileProducts(first: 7) {
        totalCount
        pageSize
        pageInfo {
          hasNextPage
          pageNumber
        }
        edges {
          node {
            ...cardProfileProductFragment
          }
        }
      }
    }
  }
  ${cardProfileProductFragment}
`

export default inProfileCollectionsFragment
